module.exports = __webpack_public_path__ + "img/repareo-suez.b4c2553f.svg";